import { combineReducers } from 'redux';

import notificationsReducer from './notifications/reducer';
import confirmationsReducer from './confirmations/reducer';

export default combineReducers({
  notifications: notificationsReducer,
  confirmations: confirmationsReducer
});
